export const CATEGORIES = [
  {
    id: 'millet-powder',
    name: 'Millet Powder',
    shortDesc: 'Ancient Indian super-grains and cold-milled nutrient-dense millet powders harvested for global health & food processing.',
    mainImage: '/products/millet.jpg',
    products: ['Finger Millet (Ragi) Powder', 'Foxtail Millet Flour', 'Pearl Millet (Bajra) Powder', 'Sorghum (Jowar) Flour'],
    count: '12+ Varieties'
  },
  {
    id: 'vegetable-powder',
    name: 'Vegetable Powder',
    shortDesc: 'Sun & low-temperature dehydrated vegetable powders offering long shelf life and natural flavor retention.',
    mainImage: '/products/tomato.jpg',
    products: ['Premium Tomato Powder', 'Dehydrated Onion Powder', 'Dehydrated Garlic Powder'],
    count: '15+ Varieties'
  },
  {
    id: 'leaf-powder',
    name: 'Leaf Powder',
    shortDesc: 'Nutrient-dense organic herbal powders harvested at peak maturity and cold-milled under strict export standards.',
    mainImage: '/products/moringa.jpg',
    products: ['Organic Moringa Powder', 'Curry Leaf Powder', 'Mint Leaf Powder', 'Tulsi Leaf Powder', 'Neem Leaf Powder'],
    count: '10+ Varieties'
  },
  {
    id: 'spices-powder',
    name: 'Spices Powder',
    shortDesc: 'Pure Indian whole and ground spices direct from certified spice belts, rich in aromatic essential oils.',
    mainImage: '/products/premium-spices.png',
    products: ['Premium Indian All Spices Powders', 'Red Chilli Powder', 'Cumin Seeds', 'Turmeric Powder', 'Coriander Powder'],
    count: '20+ Varieties'
  },
  {
    id: 'fruit-powder',
    name: 'Fruit Powder',
    shortDesc: 'Dehydrated fruit powders maintaining natural flavor and zero moisture compromise.',
    mainImage: '/products/mango-powder.png',
    products: ['Strawberry Powder', 'Banana Powder', 'Mango Powder', 'Amla Powder', 'Pomegranate Powder'],
    count: '18+ Varieties'
  }
];

export const PRODUCTS = [
  {
    id: 'millet-products',
    slug: 'millet-products',
    name: 'Organic Millet Powders & Grains',
    category: 'Millet Powder',
    image: '/products/millet.jpg',
    origin: 'Tamil Nadu & Karnataka, India',
    description: '100% natural, gluten-free ancient Indian millet powders (Ragi, Foxtail, Pearl Millet, Sorghum) cold-milled to preserve dietary fibre, calcium, and bio-active micro-nutrients.',
    specs: {
      'Purity': '99.5% Cleaned & De-hulled',
      'Moisture': 'Max 8.0%',
      'Gluten Content': '0% (Gluten-Free Certified)',
      'Mesh Size': '80 - 100 Fine Mesh'
    },
    gallery: [
      '/products/millet.jpg',
      '/products/gallery/millet-products-1.jpg',
      '/products/gallery/millet-products-2.jpg',
      '/products/gallery/millet-products-3.jpg'
    ]
  },
  {
    id: 'ragi-millet',
    slug: 'ragi-millet',
    name: 'Finger Millet (Ragi) Powder',
    category: 'Millet Powder',
    image: '/products/ragi-millet.jpg',
    origin: 'Tamil Nadu & Karnataka, India',
    description: 'Calcium-rich organic Finger Millet (Ragi) powder cold-milled from top quality de-hulled grains. High dietary fiber and zero gluten.',
    specs: {
      'Calcium Content': 'High (344mg / 100g)',
      'Moisture': 'Max 7.5%',
      'Purity': '99.8% Cleaned',
      'Mesh Size': '80 - 100 Mesh'
    },
    gallery: [
      '/products/ragi-millet.jpg',
      '/products/gallery/ragi-millet-1.jpg',
      '/products/gallery/ragi-millet-2.jpg',
      '/products/gallery/ragi-millet-3.jpg'
    ]
  },
  {
    id: 'foxtail-millet',
    slug: 'foxtail-millet',
    name: 'Foxtail Millet Flour',
    category: 'Millet Powder',
    image: '/products/foxtail-millet.jpg',
    origin: 'Andhra Pradesh & Karnataka, India',
    description: 'Nutrient-dense golden Foxtail millet grain and flour rich in iron, protein, and complex carbohydrates for healthy food processing.',
    specs: {
      'Protein Content': '12.3%',
      'Moisture': 'Max 8.0%',
      'Gluten Content': '0%',
      'Mesh Size': '80 Mesh'
    },
    gallery: [
      '/products/foxtail-millet.jpg',
      '/products/gallery/foxtail-millet-1.jpg',
      '/products/gallery/foxtail-millet-2.jpg',
      '/products/gallery/foxtail-millet-3.jpg'
    ]
  },
  {
    id: 'bajra-millet',
    slug: 'bajra-millet',
    name: 'Pearl Millet (Bajra) Powder',
    category: 'Millet Powder',
    image: '/products/bajra-millet.jpg',
    origin: 'Rajasthan & Gujarat, India',
    description: 'Energy-dense Pearl Millet (Bajra) flour packed with magnesium, potassium, and zinc for bakery and staple food applications.',
    specs: {
      'Iron & Magnesium': 'Rich',
      'Moisture': 'Max 8.0%',
      'Mesh Size': '80 Mesh',
      'Purity': '99.5%'
    },
    gallery: [
      '/products/bajra-millet.jpg',
      '/products/gallery/bajra-millet-1.jpg',
      '/products/gallery/bajra-millet-2.jpg',
      '/products/gallery/bajra-millet-3.jpg'
    ]
  },
  {
    id: 'jowar-millet',
    slug: 'jowar-millet',
    name: 'Sorghum (Jowar) Flour',
    category: 'Millet Powder',
    image: '/products/jowar-millet.jpg',
    origin: 'Maharashtra & Karnataka, India',
    description: 'Pure white Sorghum (Jowar) flour cold-ground from premium whole grains. Ideal for gluten-free baking and food formulations.',
    specs: {
      'Dietary Fiber': 'High (9.7g / 100g)',
      'Moisture': 'Max 7.5%',
      'Gluten Content': '0%',
      'Mesh Size': '80 - 100 Mesh'
    },
    gallery: [
      '/products/jowar-millet.jpg',
      '/products/gallery/jowar-millet-1.jpg',
      '/products/gallery/jowar-millet-2.jpg',
      '/products/gallery/jowar-millet-3.jpg'
    ]
  },
  {
    id: 'tomato-powder',
    slug: 'tomato-powder',
    name: 'Premium Tomato Powder',
    category: 'Vegetable Powder',
    image: '/products/tomato.jpg',
    origin: 'Maharashtra, India',
    description: '100% natural spray-dried and dehydrated tomato powder. Features fast cold-water solubility (98.5%) and rich natural lycopene content ideal for instant soups, sauces, and seasonings.',
    specs: {
      'Solubility': '98.5% Dispersible',
      'Moisture': 'Max 4.5%',
      'pH Value': '4.0 - 4.5'
    },
    gallery: [
      '/products/tomato.jpg',
      '/products/gallery/tomato-powder-1.jpg',
      '/products/gallery/tomato-powder-2.jpg',
      '/products/gallery/tomato-powder-3.jpg'
    ]
  },
  {
    id: 'moringa-powder',
    slug: 'moringa-powder',
    name: 'Moringa',
    category: 'Leaf Powder',
    image: '/products/moringa.jpg',
    origin: 'Tamil Nadu, India',
    description: 'Nutrient-dense organic moringa leaf powder harvested at peak maturity and processed under ultra-hygienic cold-milling standards.',
    specs: {
      'Protein Content': '> 27%',
      'Mesh Size': '100 Mesh Fine',
      'Moisture': 'Max 6.0%'
    },
    gallery: [
      '/products/moringa.jpg',
      '/products/gallery/moringa-powder-1.jpg',
      '/products/gallery/moringa-powder-2.jpg',
      '/products/gallery/moringa-powder-3.jpg'
    ]
  },
  {
    id: 'curry-leaf-powder',
    slug: 'curry-leaf-powder',
    name: 'Curry Leaf Powder',
    category: 'Leaf Powder',
    image: '/products/curry-leaf-powder.png',
    origin: 'Tamil Nadu, India',
    description: 'Aromatic and flavorful curry leaf powder, shade-dried and cold-milled to retain maximum volatile oils and natural green color.',
    specs: {
      'Moisture': 'Max 6.0%',
      'Mesh Size': '80 Mesh'
    },
    gallery: [
      '/products/curry-leaf-powder.png',
      '/products/curry-leaf-powder.png',
      '/products/curry-leaf-powder.png',
      '/products/curry-leaf-powder.png'
    ]
  },
  {
    id: 'mint-leaf-powder',
    slug: 'mint-leaf-powder',
    name: 'Mint Leaf Powder',
    category: 'Leaf Powder',
    image: '/products/mint-leaf-powder.png',
    origin: 'Uttar Pradesh, India',
    description: 'Refreshing organic mint leaf powder with a high concentration of menthol, processed under strict temperature control for pharmaceutical and food use.',
    specs: {
      'Menthol Content': 'High',
      'Moisture': 'Max 7.0%'
    },
    gallery: [
      '/products/mint-leaf-powder.png',
      '/products/mint-leaf-powder.png',
      '/products/mint-leaf-powder.png',
      '/products/mint-leaf-powder.png'
    ]
  },
  {
    id: 'premium-spices',
    slug: 'premium-spices',
    name: 'Premium All Indian Spices',
    category: 'Spices Powder',
    image: '/products/premium-spices.png',
    origin: 'Kerala & Tamil Nadu, India',
    description: 'Aromatic Indian spices ground using low-temperature cryogenic milling to preserve essential oils and rich natural flavors.',
    specs: {
      'Purity': '100% Authentic',
      'Mesh Size': '80 - 100 Mesh'
    },
    gallery: [
      '/products/premium-spices.png',
      '/products/gallery/premium-spices-1.png',
      '/products/gallery/premium-spices-2.png',
      '/products/gallery/premium-spices-3.png'
    ]
  },
  {
    id: 'red-chilli-powder',
    slug: 'red-chilli-powder',
    name: 'Red Chilli Powder',
    category: 'Spices Powder',
    image: '/products/red-chilli-powder.png',
    origin: 'Guntur, Andhra Pradesh, India',
    description: 'Vibrant, fiery red chilli powder cold-milled from premium dried Guntur chillies, providing perfect heat and deep color for global cuisines.',
    specs: {
      'SHU (Heat)': '25,000 - 35,000',
      'Moisture': 'Max 10.0%'
    },
    gallery: [
      '/products/red-chilli-powder.png',
      '/products/red-chilli-powder.png',
      '/products/red-chilli-powder.png',
      '/products/red-chilli-powder.png'
    ]
  },
  {
    id: 'cumin-seeds',
    slug: 'cumin-seeds',
    name: 'Cumin Seeds',
    category: 'Spices Powder',
    image: '/products/cumin-seeds.png',
    origin: 'Gujarat & Rajasthan, India',
    description: 'Premium sortex-cleaned Indian cumin seeds (Jeera) rich in volatile oils, offering intense earthy flavor and aroma for robust food processing.',
    specs: {
      'Purity': '99.5% Machine Cleaned',
      'Volatile Oil': 'Min 2.5%'
    },
    gallery: [
      '/products/cumin-seeds.png',
      '/products/cumin-seeds.png',
      '/products/cumin-seeds.png',
      '/products/cumin-seeds.png'
    ]
  },
  {
    id: 'beetroot-powder',
    slug: 'beetroot-powder',
    name: 'Beetroot',
    category: 'Vegetable Powder',
    image: '/products/beetroot.jpg',
    origin: 'Rajasthan, India',
    description: 'Fresh cold-milled beetroot powder rich in natural nitrates and vibrant red betalain pigments. Excellent natural food colorant.',
    specs: {
      'Moisture': 'Max 5.0%',
      'Mesh Size': '80 Mesh'
    },
    gallery: [
      '/products/beetroot.jpg',
      '/products/gallery/beetroot-powder-1.jpg',
      '/products/gallery/beetroot-powder-2.jpg',
      '/products/gallery/beetroot-powder-3.jpg'
    ]
  },
  {
    id: 'onion-powder',
    slug: 'onion-powder',
    name: 'Onion',
    category: 'Vegetable Powder',
    image: '/products/onion.jpg',
    origin: 'Gujarat, India',
    description: 'Crisp, white dehydrated onion flakes and powder offering concentrated sweet onion flavor without peeling labor or weeping tears.',
    specs: {
      'Moisture': 'Max 5.0%',
      'Particle Size': '80 - 100 Mesh'
    },
    gallery: [
      '/products/onion.jpg',
      '/products/gallery/onion-powder-1.jpg',
      '/products/gallery/onion-powder-2.jpg',
      '/products/gallery/onion-powder-3.jpg'
    ]
  },
  {
    id: 'garlic-powder',
    slug: 'garlic-powder',
    name: 'Garlic',
    category: 'Vegetable Powder',
    image: '/products/garlic.jpg',
    origin: 'Madhya Pradesh, India',
    description: 'Pungent, aromatic dehydrated garlic prepared from sound mature garlic bulbs with high allicin retention (>1.2%).',
    specs: {
      'Allicin Content': '> 1.2%',
      'Moisture': 'Max 6.0%'
    },
    gallery: [
      '/products/garlic.jpg',
      '/products/gallery/garlic-powder-1.jpg',
      '/products/gallery/garlic-powder-2.jpg',
      '/products/gallery/garlic-powder-3.jpg'
    ]
  },
  {
    id: 'strawberry-powder',
    slug: 'strawberry-powder',
    name: 'Strawberry Powder',
    category: 'Fruit Powder',
    image: '/products/strawberry-powder.png',
    origin: 'India',
    description: '100% Natural | No Added Sugar | Rich in Vitamin C',
    status: 'Inquiry Only',
    specs: {
      'Moisture': 'Max 5.0%'
    },
    gallery: [
      '/products/strawberry-powder.png',
      '/products/gallery/strawberry-powder-1.png',
      '/products/gallery/strawberry-powder-2.png',
      '/products/gallery/strawberry-powder-3.png'
    ]
  },
  {
    id: 'banana-powder',
    slug: 'banana-powder',
    name: 'Banana Powder',
    category: 'Fruit Powder',
    image: '/products/banana-powder.png',
    origin: 'India',
    description: '100% Natural | Plant Based | Rich in Potassium',
    status: 'Inquiry Only',
    specs: {
      'Moisture': 'Max 5.0%'
    },
    gallery: [
      '/products/banana-powder.png',
      '/products/gallery/banana-powder-1.png',
      '/products/gallery/banana-powder-2.png',
      '/products/gallery/banana-powder-3.png'
    ]
  },
  {
    id: 'mango-powder',
    slug: 'mango-powder',
    name: 'Mango Powder',
    category: 'Fruit Powder',
    image: '/products/mango-powder.png',
    origin: 'India',
    description: '100% Natural | Tangy & Sweet | High in Vitamins',
    status: 'Inquiry Only',
    specs: {
      'Moisture': 'Max 5.0%'
    },
    gallery: [
      '/products/mango-powder.png',
      '/products/mango-powder.png',
      '/products/mango-powder.png',
      '/products/mango-powder.png'
    ]
  },
  {
    id: 'amla-powder',
    slug: 'amla-powder',
    name: 'Amla Powder',
    category: 'Fruit Powder',
    image: '/products/amla-powder.png',
    origin: 'India',
    description: '100% Natural | Rich in Vitamin C | Antioxidant Powerhouse',
    status: 'Inquiry Only',
    specs: {
      'Moisture': 'Max 5.0%'
    },
    gallery: [
      '/products/amla-powder.png',
      '/products/amla-powder.png',
      '/products/amla-powder.png',
      '/products/amla-powder.png'
    ]
  },
  {
    id: 'pomegranate-powder',
    slug: 'pomegranate-powder',
    name: 'Pomegranate Powder',
    category: 'Fruit Powder',
    image: '/products/pomegranate-powder.png',
    origin: 'India',
    description: '100% Natural | Sweet & Tart | Rich in Antioxidants',
    status: 'Inquiry Only',
    specs: {
      'Moisture': 'Max 5.0%'
    },
    gallery: [
      '/products/pomegranate-powder.png',
      '/products/pomegranate-powder.png',
      '/products/pomegranate-powder.png',
      '/products/pomegranate-powder.png'
    ]
  },
  {
    id: 'turmeric-powder',
    slug: 'turmeric-powder',
    name: 'Turmeric Powder',
    category: 'Spices Powder',
    image: '/products/turmeric-powder-new.png',
    origin: 'Erode, Tamil Nadu, India',
    description: 'Vibrant, golden-yellow turmeric powder cold-milled from premium dried Erode turmeric fingers. High curcumin content and rich earthy flavor.',
    specs: {
      'Curcumin Content': 'Min 3.0%',
      'Moisture': 'Max 10.0%'
    },
    gallery: [
      '/products/turmeric-powder-new.png',
      '/products/turmeric-powder-new.png',
      '/products/turmeric-powder-new.png',
      '/products/turmeric-powder-new.png'
    ]
  },
  {
    id: 'coriander-powder',
    slug: 'coriander-powder',
    name: 'Coriander Powder',
    category: 'Spices Powder',
    image: '/products/coriander-powder.png',
    origin: 'Rajasthan, India',
    description: 'Aromatic, earthy coriander powder cold-milled from premium dried Indian coriander seeds. Provides a warm, citrusy flavor profile for global cuisines.',
    specs: {
      'Purity': '100% Authentic',
      'Moisture': 'Max 9.0%'
    },
    gallery: [
      '/products/coriander-powder.png',
      '/products/coriander-powder.png',
      '/products/coriander-powder.png',
      '/products/coriander-powder.png'
    ]
  },
  {
    id: 'tulsi-leaf-powder',
    slug: 'tulsi-leaf-powder',
    name: 'Tulsi Leaf Powder',
    category: 'Leaf Powder',
    image: '/products/tulsi-leaf-powder.png',
    origin: 'Uttar Pradesh, India',
    description: 'Sacred Tulsi (Holy Basil) leaf powder, gently shade-dried and finely milled to preserve its rich aromatic essential oils and potent therapeutic properties.',
    specs: {
      'Purity': '100% Natural',
      'Moisture': 'Max 8.0%'
    },
    gallery: [
      '/products/tulsi-leaf-powder.png',
      '/products/tulsi-leaf-powder.png',
      '/products/tulsi-leaf-powder.png',
      '/products/tulsi-leaf-powder.png'
    ]
  },
  {
    id: 'neem-leaf-powder',
    slug: 'neem-leaf-powder',
    name: 'Neem Leaf Powder',
    category: 'Leaf Powder',
    image: '/products/neem-leaf-powder.png',
    origin: 'Tamil Nadu, India',
    description: 'Premium bitter Neem leaf powder, cold-processed from mature, healthy neem leaves. Ideal for cosmetic, agricultural, and traditional wellness formulations.',
    specs: {
      'Purity': '100% Authentic',
      'Moisture': 'Max 7.0%'
    },
    gallery: [
      '/products/neem-leaf-powder.png',
      '/products/neem-leaf-powder.png',
      '/products/neem-leaf-powder.png',
      '/products/neem-leaf-powder.png'
    ]
  }
];

export const PROCESS_STEPS = [
  { step: '01', title: 'Sourcing', desc: 'Direct partnerships with select farmers ensuring raw material excellence at the root level.' },
  { step: '02', title: 'Processing', desc: 'Advanced dehydration and milling techniques preserving essential nutrients and rich flavors.' },
  { step: '03', title: 'Quality Check', desc: 'Rigorous multi-stage laboratory testing aligning with stringent international food safety standards.' },
  { step: '04', title: 'Global Shipping', desc: 'Secure, climate-controlled packaging and efficient logistics guaranteeing pristine arrival worldwide.' }
];
